import React from "react";
import {useTranslation} from "react-i18next";
import btorageBooster from "../../../assets/img/btorageBooster.png";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  쇼핑몰 상품연동 상태에서 '앱 설치' 클릭 시 노출되는 예외 안내팝업
 * ════════════════════════════════════════════════════════════════════════════════
 *  - 웹(PC/Mobile)에 쇼핑몰 상품데이터가 연동/보관된 상태에서만 노출한다.
 *  - {그래도설치} : 기존 앱 설치 로직 실행  /  {알겠어요} : 팝업만 닫는다.
 * ════════════════════════════════════════════════════════════════════════════════
 */
function StoreLinkAppPopup({theme, onInstall, onClose}) {

    const {t} = useTranslation();

    return (
        <div className="up-scope" data-theme={theme}
             style={{
                 position: "fixed", inset: 0, zIndex: 2100,
                 background: "rgba(19,20,23,0.55)", backdropFilter: "blur(3px)",
                 display: "flex", alignItems: "center", justifyContent: "center", padding: "18px",
             }}>
            <div className="up-card" style={{width: "100%", maxWidth: "420px", padding: 0, overflow: "hidden", borderRadius: "20px"}}>
                <div style={{height: "4px", background: "linear-gradient(90deg, var(--up-brand), var(--up-brand-2))"}}/>

                <div style={{display: "flex", alignItems: "center", gap: "9px", padding: "20px 24px 0"}}>
                    <img src={btorageBooster} alt="Btorage" style={{height: "22px", objectFit: "contain"}}/>
                    <p style={{margin: 0, fontFamily: "'LINESeedKR-Bd', sans-serif", fontSize: "16px", color: "var(--up-text)"}}>
                        {t('slAppTitle')}
                    </p>
                </div>

                <div style={{padding: "16px 24px 0"}}>
                    <div style={{
                        background: "var(--up-brand-soft)", border: "1px solid var(--up-border)",
                        borderRadius: "14px", padding: "16px",
                    }}>
                        <p style={{margin: 0, fontSize: "13.5px", lineHeight: 1.95, color: "var(--up-text-sub)", wordBreak: "break-word"}}>
                            {t('slAppCont')}
                        </p>
                    </div>
                </div>

                <div style={{padding: "18px 24px 24px", display: "flex", gap: "9px"}}>
                    <button className="up-btn-ghost" onClick={onInstall}
                            style={{flex: 1, height: "46px", fontSize: "13.5px", borderRadius: "12px"}}>
                        {t('slAppInstall')}
                    </button>
                    <button className="up-btn-primary" onClick={onClose}
                            style={{flex: 1, height: "46px", fontSize: "13.5px", borderRadius: "12px", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>
                        {t('slAppOk')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StoreLinkAppPopup
